import { useQuery } from '@tanstack/react-query';

import { transactionsService } from '@/services/apiClient';
import type { TransactionFilters } from '@/types/transactions';

/**
 * Transactions Hooks
 * React Query hooks for /api/v1/transactions/* endpoints
 */

// Query keys
export const transactionKeys = {
  all: ['transactions'] as const,
  list: (filters: TransactionFilters) => [...transactionKeys.all, 'list', filters] as const,
};

/**
 * Hook to fetch transactions with filters
 */
export const useTransactions = (filters?: TransactionFilters) => {
  return useQuery({
    queryKey: transactionKeys.list(filters || {}),
    queryFn: () => transactionsService.getTransactions(filters || {}),
    staleTime: 2 * 60 * 1000, // 2 minutes (more frequent for transactions)
  });
};
